module.exports = __webpack_public_path__ + "static/traditions-technology-boost-bee-health-32b74259f5001c8975ed6efc61382e8f.jpg";